
export interface EnrichmentData {
  title: string;
  imageSrc: string;
  tags: string[];
  backgroundColor: string;
}

export interface FoodTheme {
  title: string;
  description: string;
  imageSrc: string;
}

export interface RandomRecipesData {
  id: number;
  thumbnail: string;
  video_id: string;
  name: string;
}

export enum TypeSuggestion {
  TASTE = 'TASTE', 
  SITUATION = 'SITUATION',
  AGE = 'AGE', 
  WEATHER = 'WEATHER',
}

export enum IDSuggestion {
  TASTE = 1, 
  SITUATION = 2,
  AGE = 3, 
  WEATHER = 4,
}

export interface ItemsMainProps {
  id: number;
  title: string;
  description: string;
  thumbnail: string;
  flavor_items?: any;
  hash_tags?: any;
  translates?: any;
  background?: string;
  handleClick: (id: number) => void;
}

export interface SectionSkeletonProps {
  className?: string;
  length?: number;
  width?: number;
  height?: number;
  circle?: boolean;
  count?: number;
}
